import {
    FETCH_ASSOCIATED_PARTIES_DATA_REQUEST,
    FETCH_CREATE_PARTY_DATA_REQUEST,
    FETCH_PARTY_INFO_REQUEST,
    FETCH_PARTY_SUGGESTION_REQUEST,
    ADD_ASSOCIATE_PARTY_REQUEST,
    DELETE_ASSOCIATE_PARTY_REQUEST,
    CHANGE_LOG_ASSOCIATE_PARTY_REQUEST,
    FETCH_ORG_ACCESS_DATA_REQUEST,
    UPDATE_ORG_ACCESS_DATA_REQUEST,
    FETCH_NOTIFICATION_PANEL_SETTING_DATA_REQUEST,
    FETCH_NOTIFICATION_LATEST_UPDATE_DATA_REQUEST,
    UPDATE_NOTIFICATION_PANEL_SETTING_DATA_REQUEST,
    UPDATE_NOTIFICATION_DATA_REQUEST,
    CHANGE_GROUP_UPDATES_REQUEST,
    RESET_WORKKARD_GROUP_COUNTER_REQUEST,
    FETCH_FILTER_GROUP_BY_DATA_REQUEST,
    CHANGE_ACTIVITY_UPDATES_REQUEST,
    FETCH_NOTIFICATION_DETAIL_DATA_REQUEST,
    GET_WORKKARD_AU_STATUS_REQUEST,
    GET_AU_COUNT_REQUEST,
    UPDATE_RECENT_NOTIFICATION_STATUS_REQUEST,
    FETCH_USER_SESSIONCONTEXT_REQUEST,
    GET_WORKKARD_SEARCH_LIST_REQUEST,
    FETCH_USER_RECENT_SEARCHES_REQUEST,
    REMOVE_RECENT_SEARCH_ITEM_REQUEST,
    FETCH_WORKKARD_SEARCH_RESULT_DATA_REQUEST,
    FETCH_ACTIVITY_SEARCH_RESULT_DATA_REQUEST,
    FETCH_NOTES_SEARCH_RESULT_DATA_REQUEST,
    FETCH_FILES_SEARCH_RESULT_DATA_REQUEST,
    FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_REQUEST,
    FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_REQUEST,
    FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_REQUEST,
    ADD_GLOBAL_SEARCH_USAGE_REQUEST,
    GET_TOPBAR_TABS_COUNT,
    UPDATE_USER_THEME,
    GET_USER_ORG_NAME_SUGGESTIONS,
    UPDATE_LAYOUT_SETTINGS,
    CHANGE_USER_ORG_TOKEN,
    UPDATE_PHONE_NUMBER,
    UPDATE_USER_DATA,
    UPDATE_AU_SETTINGS,
    UPDATE_TIME_ZONE,
    FETCH_PARTY_STATES_REQUEST,
    CREATE_USER_LICENSE,
    UPDATE_USER_LICENSE,
    DELETE_USER_LICENSE,
    UPDATE_CONTACT_RELATIONSHIP_REQUEST,
    FETCH_CARRIER_LIST,
    FETCH_REALTIONSHIP,
    GET_USER_INFO,
    GET_NOTIFICATION_SETTINGS,
    UPDATE_NOTIFICATION_SETTINGS
} from "../Header/actions/actionConstants";
import AppConstants from "../../config/appConstants";

const mappingObject= {};

mappingObject[GET_USER_INFO] = {
  url: "/2.0/user/",
  method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_ASSOCIATED_PARTIES_DATA_REQUEST] = {
    url: "/glbllst",
    method: AppConstants.httpMethod.GET
  }
  
  mappingObject[FETCH_CREATE_PARTY_DATA_REQUEST] = {
    url: "/party",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_CARRIER_LIST] = {
    url: "/carriers",
    method: AppConstants.httpMethod.GET
  }
  
  mappingObject[FETCH_PARTY_INFO_REQUEST] = {
    url: "/dpar",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_PARTY_STATES_REQUEST] = {
    url: "/propStates",
    method: AppConstants.httpMethod.GET
  }
  
  mappingObject[FETCH_PARTY_SUGGESTION_REQUEST] = {
    url: "/atocmplpar",
    method: AppConstants.httpMethod.GET
  }
  
  mappingObject[ADD_ASSOCIATE_PARTY_REQUEST] = {
    url: "/aspar",
    method: AppConstants.httpMethod.POST
  }
  
  mappingObject[DELETE_ASSOCIATE_PARTY_REQUEST] = {
    url: "/delpar",
    method: AppConstants.httpMethod.POST
  }
  
  mappingObject[CHANGE_LOG_ASSOCIATE_PARTY_REQUEST] = {
    url: "/party/logs",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_ORG_ACCESS_DATA_REQUEST] = {
    url: "/orgviews",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[UPDATE_ORG_ACCESS_DATA_REQUEST] = {
    url: "/CommunityAccess/ResetAccess",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[FETCH_NOTIFICATION_PANEL_SETTING_DATA_REQUEST] = {
    url: "/userprofile/getactivityupdatepanelfiltersetting",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_NOTIFICATION_LATEST_UPDATE_DATA_REQUEST]={
    url: "/activityupdate/GetUpdates",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[UPDATE_NOTIFICATION_PANEL_SETTING_DATA_REQUEST] = {
    url: "/userprofile/updateactivityupdatepanelfiltersetting",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[UPDATE_NOTIFICATION_DATA_REQUEST]={
    url: "/activityupdate/GetOlderUpdates",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[CHANGE_GROUP_UPDATES_REQUEST] = {
    url: "/chnggrpupdates",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[RESET_WORKKARD_GROUP_COUNTER_REQUEST]= {
    url: "/resetwkdgrpcounter",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[FETCH_FILTER_GROUP_BY_DATA_REQUEST] = {
    url: "/updategrpwkdsetting",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[CHANGE_ACTIVITY_UPDATES_REQUEST] = {
    url: "/activityupdate/changeactivityupdatestatus",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[FETCH_NOTIFICATION_DETAIL_DATA_REQUEST]={
    url: "/wkdUpdates",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[GET_WORKKARD_AU_STATUS_REQUEST]={
    url: "/wkdaustatus",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[GET_AU_COUNT_REQUEST]={
    url: "/activityupdate/getnotificationcounter",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[UPDATE_RECENT_NOTIFICATION_STATUS_REQUEST] = {
    url: "/activityupdate/UpdateRecentNotificationStatus",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[FETCH_USER_SESSIONCONTEXT_REQUEST] = {
    url: "/getusersessioninfo",
    method: AppConstants.httpMethod.GET
  }
  

  mappingObject[GET_WORKKARD_SEARCH_LIST_REQUEST] = {
    url: "/1.0/search/prefetch",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_USER_RECENT_SEARCHES_REQUEST] = {
    url: "/recentsearches",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[REMOVE_RECENT_SEARCH_ITEM_REQUEST] = {
    url: "/deletesearch",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[FETCH_WORKKARD_SEARCH_RESULT_DATA_REQUEST] = {
    url: "/sgetclm",
    method: AppConstants.httpMethod.GET
  }
  mappingObject[FETCH_ACTIVITY_SEARCH_RESULT_DATA_REQUEST] = {
    url: "/sgetact",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_NOTES_SEARCH_RESULT_DATA_REQUEST] = {
    url: "/sgetnotes",
    method: AppConstants.httpMethod.GET
  }
  mappingObject[FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_REQUEST] = {
    url: "/sgetactowner",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_REQUEST] = {
    url: "/sgetactassig",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_FILES_SEARCH_RESULT_DATA_REQUEST] = {
    url: "/sgetfiles",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_REQUEST] = {
    url: "/sgetwrkspon",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[ADD_GLOBAL_SEARCH_USAGE_REQUEST] = {
    url: "/addautosuggestuasge",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[GET_TOPBAR_TABS_COUNT] = {
    url: "/gettabcounts",
    method: AppConstants.httpMethod.GET
  }
  
  mappingObject[UPDATE_USER_THEME] = {
    url: "/updatetheme",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[GET_USER_ORG_NAME_SUGGESTIONS] = {
    url: "/2.0/user/orgs",
    method: AppConstants.httpMethod.GET
  }
  
  mappingObject[UPDATE_LAYOUT_SETTINGS] = {
    url: "/uplayotsettng",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[CHANGE_USER_ORG_TOKEN] = {
    url: "/switchorgview",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[UPDATE_PHONE_NUMBER]= {
    url: "/UserProfile/UpdatePhone",
    method: AppConstants.httpMethod.POST
  };

  mappingObject[UPDATE_AU_SETTINGS]= {
    url: "/UserProfile/UpdateAUSetting",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[GET_NOTIFICATION_SETTINGS] = {
    url: "/1.0/notification/settings",
    method: AppConstants.httpMethod.GET
  }

  mappingObject[UPDATE_NOTIFICATION_SETTINGS] = {
    url: "/1.0/notification/settings",
    method: AppConstants.httpMethod.PUT
  }

  mappingObject[UPDATE_TIME_ZONE] = {
    url: "/uutz",
    method: AppConstants.httpMethod.POST
  }
  
  mappingObject[CREATE_USER_LICENSE] = {
    url: "/cul",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[UPDATE_USER_LICENSE] = {
    url: "/updateul",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[DELETE_USER_LICENSE] = {
    url: "/deleteul",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[UPDATE_CONTACT_RELATIONSHIP_REQUEST] = {
    url: "/updcntcttyp",
    method: AppConstants.httpMethod.POST
  }

  mappingObject[FETCH_REALTIONSHIP] = {
    url:'/organization/relationship',
    method: AppConstants.httpMethod.GET
  }

  export default mappingObject;
